/*global angular */

(function () {
    'use strict';

    angular.module('sky.accordion', ['sky.accordion.uibaccordiongroup']);
})();